var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.options),function(option,key){return [_c('BaseButton',{key:key,staticClass:"mx-1 button-option",class:{ active: _vm.active(key) },on:{"click":function($event){return _vm.toggle(key)}}},[_vm._v(_vm._s(option))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }